import { render, staticRenderFns } from "./LearningUnitTypeSelector.vue?vue&type=template&id=62cb0cea&scoped=true&"
import script from "./LearningUnitTypeSelector.vue?vue&type=script&lang=js&"
export * from "./LearningUnitTypeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cb0cea",
  null
  
)

export default component.exports